import React, { Component } from 'react';
import * as Common from '../../helpers/Common';
import * as Config from '../../config/Config';
const $=window.$;
class Sharenotes extends Component {
    constructor(props) {
        super(props)

    }
    fnIsSeeknotesSelected() {
     let chkLrID = $('input[type="checkbox"]:checked').length;
        if(chkLrID > 0){
            $('#divSharenotes').css('display','none');
             let learnerID = Common.getUserData("id", true);      
             let ids = $('#sharenotes_form').serializeArray();
             
            Common.reactLoader("show", "Please wait...");
            fetch(Config.domainUrl+'writing-pad/sharenotes-insert', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':'Bearer ' +Common.getTokenData()
                },
                body: JSON.stringify({
                  learnerID:learnerID,
                  ids:ids
                })
                }).then((response) => response.json())
                .then((responseJson) => { 
                   this.props.changedStatus('changed');               
                Common.reactLoader("hide");
                Common.downTabClose();
            });
                        
                
            return true;
        } else {
            $('#divSharenotes').css('display','block');
            return false;
        }
    }
    componentDidMount () {
       
    }    

    render () {
        let nochk=0;
        let share_notes_list ='';
        if(this.props.data != undefined || this.props.data != null){
         share_notes_list = this.props.data.map((key,index)=>{
                {(key.status==false) ?
                    nochk = nochk+1
                    :
                    ''
                }
        return <div key={`main${index}`} className="seeknotes_list" > 
                    {(key.status!=false) ?
                        ''
                        :
                            <div>
                               <input type="checkbox" name="chkLrID[]" id="chkLrID" value={key.learner_id_pk} />
                                 {key.learner_name}
                            </div>
                        }
                        {(key.status==1) ?
                          <div>( Notes already shared )</div>
                          :
                          ''
                        }
                        {(key.status==2) ?
                          <div>( Notes share request awaiting)</div>
                          :
                          ''
                        }
                        
                </div>
      });
}

        return (
             <div className="tabgrey">
                 
                  <form name="sharenotes_form" id="sharenotes_form" method="post">
                    <div id="sharenotes_view">                     
                      

                         {(share_notes_list!='') ? 
                           <div> <div className="ans-explanation"> Choose any buddy to share your notes with and click on "Share" button. </div>
                      <h2 className="bluetxt seek-head">Buddies <a  href="#/buddychat" target="_blank" className="mang-buddy" title="Manage Buddies">Manage Buddies</a></h2>
                      <div id="divSharenotes" style={{display:'none'}}><font color="#FF0000">Please select</font></div>
                      {share_notes_list}
                                {(nochk!=0)?
                                  <div className="seek-btn">
                                    <input type="hidden" name="hidnotes" id="hidnotes" value={nochk} />
                                    <div className="button"><span>
                                      <input type="button" name="btnSave" value="Share" alt="Share" onClick={(e) =>this.fnIsSeeknotesSelected()} title="Share"/>
                                      </span></div>
                                  </div>
                                  :
                                  ''
                              }
                          </div>
                          :
                          <div> Either you have shared notes with all your buddies or there are 
                          no buddies for you. Please click on "Manage Buddies" to add 
                          new buddies. <a href="#/buddychat" target="_blank" style={{float:'right'}} title="Manage Buddies" className="button-accept">Manage Buddies</a></div>
                      }
                      
                    </div>
                  </form>
                </div>                 
        )
    }
}

export default Sharenotes


// WEBPACK FOOTER //
// ./src/lr_dlr_components/notepad_partials/Sharenotes.js